var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cc-premium',{attrs:{"type":"energy","features":2,"days-left":_vm.user.premiumEnergyLeft,"level":7}})}
var staticRenderFns = []
export { render, staticRenderFns }